<template>
  <DialogTemplateToolkit
    :dialog.sync="dialog"
    first_btn="Common.Send"
    :loading="loading"
    :title="title"
    @apply="apply"
    @close="dialog=false"
    @open="clear">
    <template v-slot:activator-btn>
      <sButton
        color="var(--white-color)"
        data-qa="ask-question-dialog"
        icon="comment"
        type="text"
        @click="dialog = true">
        {{ $t('Tenders.AskQuestion') }}
      </sButton>
    </template>
    <template v-slot:card-text>
      <v-card-actions class="align-start px-0 flex flex-wrap align-top">
        <sForm
          ref="questionForm"
          class="width-70 pr-3"
          :disabled="loading"
          :model="forma">
          <sFormItem
            prop="message"
            :rules="commentValidateRule">
            <sInput
              autofocus
              data-qa="question-text"
              :disabled="!!loading"
              :max-rows="15"
              rows="11"
              show-word-limit
              type="textarea"
              :value.sync="forma.message"/>
          </sFormItem>
          <ImportBlock
            :create-file-handler="createFileHandler"
            :disabled="!!loading"
            file_size="5"
            :files="filesFormat"
            files-types
            inline-style="width: 100%"
            :multiple="false"
            @deleteFile="createFileHandler(null)"/>
        </sForm>
        <div class="width-30">
          <div class="ask-question-info">
            <div class="bold font-size-14">
              {{ $t('Common.QuestionToParticipants') }}
            </div>
            <div class="mt-2 font-size-14">
              {{ $t('Common.QuestionToParticipantsText') }}
            </div>
          </div>
        </div>
      </v-card-actions>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import ImportBlock from 'components/common/blocks/ImportBlock.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import ApplicationApi from '@/api/applicationApi'
const api = new ApplicationApi()
import { debounce } from 'toolkit/utils/util'
import { modalMixin, validateRuls } from 'mixins'
import { QuestionFile } from '@/types/commonFile.js'

import textFunctions from 'mixins/textFunctions'

/**
* задать вопрос поставщикам. Пункт в меню снекбара
*/
export default {
  name: 'AskQuestion',
  mixins: [ validateRuls, modalMixin, textFunctions ],
  data() {
    return {
      dialog: false,
      loading: false,
      files: [],
      filesFormat: [],
      forma: {
        message: '',
        userIds: [],
      },
    }
  },
  props: {
    bids: {
      type: Array,
      require: true
    },
    tender: {
      type: Object,
      require: true
    },
  },
  computed: {
    participants() {
      return Object.keys( this.$_.groupBy(this.bids, 'bidderInfo.organizationName') ) || []
    },
    title() {
      if (this.bids.length === 1) {
        return `<div
            data-qa="title-row1">
            ${this.bigFirstLetter(this.$t('Tenders.AskQuestion'))} ${this.$t('Tenders.ForTender')} #${this.tender.tenderNumber}
          </div>
          <div data-qa="title-row2">
            ${this.participants && this.participants.length ? ` ${this.$t('Common.For')} ${this.participants[0]}` : '' }
          </div>`
      }

      return `<div
            class="width-100"
            data-qa="title-row1">
            ${this.bigFirstLetter(this.$t('Tenders.AskQuestion'))}
          </div>
          <div
            data-qa="title-row2"
            style="font-size: 16px; font-weight: 400; line-height: 20px;">
            ${ this.participants?.length ? this.participants.join(', ') : '–' }
          </div>`
    },
    uniqueParticipantUserId() {
      return this.bids.map(i => i.bidderInfo.participantUserId).filter((v, i, a) => a.indexOf(v) === i)
    },
  },
  methods: {
    apply: debounce(async function () {
      this.$refs.questionForm.validate(async (valid) => {
        if (!valid) {
          this.loading = false
          return
        }
        this.loading = true
        this.forma.userIds = this.uniqueParticipantUserId
        this.forma.message = this.$_escapeHtml(this.forma.message)
        await api.addOrChangeQuestion(this.tender.tenderId, null, this.forma, this.files || null)
          .then(res => {
            if (res) {
              if (res.success) {
                this.dialog = false
                this.clear()
                this.$emit('hideActions')
                this.$root.$emit('updateHistory')
              } else {
                this.$notice.warning({
                  title: this.$t('Common.ErrorTitle'),
                  message: res?.message || this.$t('Errors.STHWrong'),
                  dangerouslyUseHTMLString: true,
                })
              }
            }
          })
          .finally(() => this.loading = false)
      })
    }, 200),
    clear() {
      this.forma.message = ''
      this.files = []
      this.filesFormat = []
    },
    createFileHandler(files) {
      if (files) {
        this.files = [files]
        this.filesFormat = [new QuestionFile( files )]
      } else  {
        this.files = []
        this.filesFormat = []
      }
    },
  },
  components: {
    ImportBlock,
    DialogTemplateToolkit
  }
}
</script>
<style lang="scss" scoped>
.ask-question-info{
  padding: 20px;
  border-radius: 8px;
  background-color: var(--v-secondary__green_chosen-base);
}
</style>
